import { SvgType } from './types'

export default function Document({ fill, style, size, viewBox }: SvgType) {
  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 7.71429H5.83333V6.28571H11.5V7.71429ZM5.83333 12H15.75V10.5714H5.83333V12ZM5.83333 14.8571H15.75V13.4286H5.83333V14.8571ZM5.83333 17.7143H15.75V16.2857H5.83333V17.7143ZM20 7V20.5714C20 21.3571 19.3625 22 18.5833 22H4.41667C3.6375 22 3 21.3571 3 20.5714V3.42857C3 2.64286 3.6375 2 4.41667 2H15.0417L20 7ZM18.5833 7.71429L14.3333 3.42857H4.41667V20.5714H18.5833V7.71429Z"
        fill={fill}
      />
    </svg>
  )
}
